import { Injectable, Inject } from '@angular/core';

import { CookieService } from './cookie.service';
import { CookieOptionsArgs } from './cookie-options-args';
import { CookieOptions } from './cookie-options';

@Injectable()
export class CookieNodeService implements CookieService {
  private defaultOptions: CookieOptions;

  private get cookies(): {[key: string]: string} {
    return this.req.cookies;
  }

  constructor(@Inject('req') private req: any,
              @Inject('res') private res: any) {
  }

  public setOptions(options: CookieOptionsArgs) {
    this.defaultOptions = Object.assign(options);
  }

  public get(key: string): string {
    return this.cookies[key];
  }

  public getObject(key: string): {[key: string]: string} {
    let value = this.get(key);
    let obj = value ? JSON.parse(value) : value
    return obj;
  }

  public getAll(): {[key: string]: string} {
    return this.cookies;
  }

  public put(key: string, value: string, options?: CookieOptionsArgs): void {
    options = this.generateOptions();
    this.res.cookie(key, value, options);
  }

  public putObject(key: string, value: {[key: string]: string}, options?: CookieOptionsArgs): void {
    this.put(key, JSON.stringify(value), options);
  }

  public remove(key: string, options?: CookieOptionsArgs): void {
    options = this.generateOptions();
    this.res.clearCookie(key, options);
  }

  public removeAll(): void {
    this.res.clearCookie();
  }

  private generateOptions(options?: CookieOptionsArgs) {
    return Object.assign({}, options, {path: '/'}, this.defaultOptions);
  }
}



// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/core/cookie/cookie-node.service.ts